import { render, staticRenderFns } from "./global-state-aggregator-wom-watcher.vue?vue&type=template&id=7a252977&scoped=true&"
import script from "./global-state-aggregator-wom-watcher.vue?vue&type=script&lang=js&"
export * from "./global-state-aggregator-wom-watcher.vue?vue&type=script&lang=js&"
import style0 from "./global-state-aggregator-wom-watcher.vue?vue&type=style&index=0&id=7a252977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a252977",
  null
  
)

export default component.exports